<div class="popup">
  <div class="popup-header">
    <h5>{{ data?.title }}</h5>
  </div>

  <div class="popup-content">
    <p>{{ data?.message }}</p>
  </div>

  <div class="popup-footer">
    <button mat-stroked-button mat-dialog-close title="Cancel">
      {{ data?.cancelLabel || 'Cancel' }}
    </button>
    <button mat-raised-button color="primary" (click)="confirm()">
      {{ data?.confirmLabel || 'Confirm' }}
    </button>
  </div>
</div>
